declare const google: Window & typeof globalThis & { accounts: any };

const formatGoogleUser = (userInfo: any, access_token: string): ISocialProfile => {
  return {
    provider_name: "google",
    token_type: "access_token",
    access_token,
    full_name: userInfo.name || `${userInfo.given_name} ${userInfo.family_name}`,
    email: userInfo.email,
  };
};

export function initGoogleSdk() {
  const googleSignInAPI = document.createElement("script");

  googleSignInAPI.setAttribute("src", "https://accounts.google.com/gsi/client");
  document.head.appendChild(googleSignInAPI);
}

export async function loginGoogle(): Promise<ISocialProfile> {
  const appConfig = useRuntimeConfig().public;
  const client_id = appConfig.APP_CUSTOMER.app_config.app_client_id_for_google;

  return new Promise((resolve, reject) => {
    const client = google.accounts.oauth2.initTokenClient({
      client_id,
      scope: "openid email profile",
      callback: async (response: any) => {
        try {
          const userInfo = await fetchUserInfo(response.access_token);
          const profile = formatGoogleUser(userInfo, response.access_token);
          resolve(profile);
        } catch (error) {
          reject(error);
        }
      },
      error_callback: (error: string) => reject(error),
    });

    client.requestAccessToken();
  });
}

async function fetchUserInfo(access_token: string | null): Promise<any> {
  return fetch("https://www.googleapis.com/oauth2/v2/userinfo", {
    headers: { Authorization: `Bearer ${access_token}` },
  }).then((response: any) => response.json());
}
